import { apiClient } from './client';
import type { FleetRef } from '@/types/oscar';

// Branches + stock locations moved to api/locations.ts (PR-20; Oscar owns the
// location hierarchy). Only the fleet proxy + fleet overlay remain here.

/** GET /api/reference/fleet — fleet list from the OnsiteCore synonym. */
export function getFleet(signal?: AbortSignal): Promise<FleetRef[]> {
  return apiClient.get<FleetRef[]>('/api/reference/fleet', signal);
}

/** PATCH /api/reference/fleet/:fleetItemId/overlay — admin only. */
export function upsertFleetOverlay(
  fleetItemId: string,
  body: { OscarNotes?: string | null },
): Promise<unknown> {
  return apiClient.patch(`/api/reference/fleet/${encodeURIComponent(fleetItemId)}/overlay`, body);
}
